import styled from 'styled-components';

import { colorWhite } from '@/styleUtils';

export const Block = styled.div`
  background-color: ${colorWhite};
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`;
export default Block;
